var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookShadow = function SvgBookShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187,
    height: 215,
    fill: "none",
    viewBox: "0 0 187 215"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#book-shadow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#book-shadow_svg__b)",
    fillOpacity: 0.2,
    d: "M17.189 35.116c.058-.97.395-1.903.97-2.686l14.705-20.023c2.885-3.929 9.111-1.888 9.111 2.987v187.023a5.046 5.046 0 0 1-5.045 5.046H12.253a5.046 5.046 0 0 1-5.037-5.346z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#book-shadow_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23221C",
    fillOpacity: 0.4,
    d: "M42.172 208.206c-.981-.446-.663-1.914.415-1.914h141.799c.954 0 1.369 1.206.617 1.792a1 1 0 0 1-.617.213h-141.8a1 1 0 0 1-.414-.091"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "book-shadow_svg__a",
    width: 49.183,
    height: 211.538,
    x: 0,
    y: 3.132,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_0_7",
    stdDeviation: 3.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "book-shadow_svg__c",
    width: 146.69,
    height: 4.888,
    x: 40.142,
    y: 204.851,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_0_7",
    stdDeviation: 0.719
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "book-shadow_svg__b",
    x1: 36.964,
    x2: 17.565,
    y1: 99.942,
    y2: 98.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23221C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2DCB0",
    stopOpacity: 0
  })))));
};
export default SvgBookShadow;